import moment from "moment";

export default {
  formataData(date) {
    return moment(String(date)).format("DD/MM/YYYY");
  },
};
